import hexBlue from "@design-system/assets/madison/MEI_HexMark-Blue.png";
import hexWhite from "@design-system/assets/madison/MEI_HexMark-White.png";
import primaryBlue from "@design-system/assets/madison/MEI_PrimaryLogo-Blue.png";
import primaryWhite from "@design-system/assets/madison/MEI_PrimaryLogo-White.png";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

/** The navy logo is for light surfaces, the white one for navy or dark ones. */
type LogoTone = "navy" | "white";

const LOGOS = {
  primary: { navy: primaryBlue, white: primaryWhite },
  mark: { navy: hexBlue, white: hexWhite },
} as const;

/**
 * Madison Energy's own logo. `variant="mark"` is the hex mark alone, for tight spaces.
 * `tone="theme"` picks navy in light mode and white in dark mode, for a surface that
 * follows the theme (the sign-in page); a fixed surface (the navy top bar) passes a tone.
 */
export function MadisonLogo({
  variant = "primary",
  tone = "theme",
  className,
}: {
  variant?: "primary" | "mark";
  tone?: LogoTone | "theme";
  className?: string;
}) {
  const { resolvedTheme } = useTheme();
  const resolved: LogoTone =
    tone === "theme" ? (resolvedTheme === "dark" ? "white" : "navy") : tone;
  return (
    <img
      src={LOGOS[variant][resolved]}
      alt="Madison Energy"
      draggable={false}
      className={cn("w-auto select-none", className)}
    />
  );
}
